
import { defineComponent, ref, computed, onMounted } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import EmailReport from './EmailReport.vue'
import SMSReport from './SMSReport.vue'
import actionChecker from '../../../../classes/action_checker'

export default defineComponent({
    components: {
        EmailReport,
        SMSReport
    },
    setup () {
        const store = useStore()
        const router = useRouter()


        return {
            //
            actionChecker
        }
    }
})
